import { all, call, takeEvery, fork } from "redux-saga/effects";
import requestFunction from "../Utils/SagaGenericFunction";

import {
  FETCH_ALL_SKILL_CENTRES,
  CREATE_SKILL_CENTRE,
  ACTIVATE_SKILL_CENTRE,
  DEACTIVATE_SKILL_CENTRE,
  EDIT_SKILL_CENTRE,
  FETCH_TOTAL_SKILL_CENTER_DETAILS,
  PRINT_SKILL_ACQUISITION,
  EXPORT_SKILL_ACQUISITION,
  FETCH_SKILL_CENTER_SELECT,
} from "../ActionTypes";


import {
  fetchAllSkillCentresSuccess,
  createSkillCentreSuccess,
  activateSkillCentreSuccess,
  deactivateSkillCentreSuccess,
  editSkillCentreSuccess,
  fetchTotalSkillCenterDetailsSuccess,
  PrintSkillAcquisitionSuccess,
  ExportSkillAcquisitionSuccess,
  exportSkillAcquisitionSuccess,
  printSkillAcquisitionSuccess,
  fetchSkillCenterSelectSuccess
} from "../Actions";


import {
  getAllCentres,
  createSkillCentre,
  activateSkillCentre,
  deactivateSkillCentre,
  editSkillCentre,
  getTotalSkillCentersDetails,
  PrintSkillAcquisition,
  ExportSkillAcquisition,
  getAllCentersSelect,
} from "../Api";


// all requests
const getAllCentresRequest = function* ({payload}) {
  yield call(requestFunction, fetchAllSkillCentresSuccess, getAllCentres, payload)
}

const createSkillCentreRequest = function* ({payload}) {
  yield call(requestFunction, createSkillCentreSuccess, createSkillCentre, payload)
}

const activateSkillCentreRequest = function* ({payload}) {
  yield call(requestFunction, activateSkillCentreSuccess, activateSkillCentre, payload)
}

const deactivateSkillCentreRequest = function* ({payload}) {
  yield call(requestFunction, deactivateSkillCentreSuccess, deactivateSkillCentre, payload)
}

const editSkillCentreRequest = function* ({payload}) {
  yield call(requestFunction, editSkillCentreSuccess, editSkillCentre, payload)
}

const getSkillCentreDetailsRequest = function* ({payload}) {
  yield call(requestFunction, fetchTotalSkillCenterDetailsSuccess, getTotalSkillCentersDetails, payload)
}
export const PrintSkillFileRequest = function*({payload}){
  yield call(requestFunction, printSkillAcquisitionSuccess, PrintSkillAcquisition, payload )
};

const exportSkillAcquisitionFileRequest = function* ({ payload }) {
  yield call(requestFunction, exportSkillAcquisitionSuccess, ExportSkillAcquisition, payload);
};
const getCenterSelectRequest = function* ({ payload }) {
  yield call(requestFunction, fetchSkillCenterSelectSuccess, getAllCentersSelect, payload);
};




// all watchers
export const getAllCentresWatcher = function* () {
  yield takeEvery(FETCH_ALL_SKILL_CENTRES, getAllCentresRequest);
}

export const createSkillCentreWatcher = function* () {
  yield takeEvery(CREATE_SKILL_CENTRE, createSkillCentreRequest)
}

export const activateSkillCentreWatcher = function* () {
  yield takeEvery(ACTIVATE_SKILL_CENTRE, activateSkillCentreRequest)
}

export const deactivateSkillCentreWatcher = function* () {
  yield takeEvery(DEACTIVATE_SKILL_CENTRE, deactivateSkillCentreRequest)
}

export const editSkillCentreWatcher = function* () {
  yield takeEvery(EDIT_SKILL_CENTRE, editSkillCentreRequest)
}

export const getSkillCentreDetailsWatcher = function* () {
  yield takeEvery(FETCH_TOTAL_SKILL_CENTER_DETAILS, getSkillCentreDetailsRequest)
}

export const printSkillCentreWatcher = function*(){
  yield takeEvery(PRINT_SKILL_ACQUISITION, PrintSkillFileRequest);
}

export const exportSkillAcquistionFileWatcher = function* () {
  yield takeEvery(EXPORT_SKILL_ACQUISITION, exportSkillAcquisitionFileRequest);
};
export const getCenterSelectWatcher = function* () {
  yield takeEvery(FETCH_SKILL_CENTER_SELECT, getCenterSelectRequest);
}



export default function* rootSaga() {
  yield all([
    fork(getAllCentresWatcher),
    fork(createSkillCentreWatcher),
    fork(activateSkillCentreWatcher),
    fork(deactivateSkillCentreWatcher),
    fork(editSkillCentreWatcher),
    fork(getSkillCentreDetailsWatcher),
    fork(printSkillCentreWatcher),
    fork(exportSkillAcquistionFileWatcher),
    fork(getCenterSelectWatcher),
  ]);
}